import { Button } from '@vilibets/vilibets-uikit/dist/atoms/Button';
import { Icon } from '@vilibets/vilibets-uikit/dist/atoms/Icon';
import { EditText, IconUser, Trash } from '@vilibets/vilibets-uikit/dist/atoms/Icons';
import { Table } from '@vilibets/vilibets-uikit/dist/atoms/Table/Table';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import PopupDelete from '../../components/PopupDelete/PopupDelete';
import { deleteUser, getWorkers } from '../../services/users';
import CreditWorkerPopup from './CreditWorkerPopup';

const Workers = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [workers, setWorkers] = useState([]);
  const [displayDeletePopup, setDisplayDeletePopup] = useState(false);
  const [deleteItem, setDeleteItem] = useState(false);
  const [displayCreditPopup, setDisplayCreditPopup] = useState(false);
  const [editableRowData, setEditableRowData] = useState(null);

  function changeOrder(column, sortedSide) {
    setSearchParams({ orderby: column, orderby_direction: sortedSide });
  }

  useEffect(() => {
    async function fetchData() {
      const response = await getWorkers(window.location.search);
      setWorkers(response);
    }
    fetchData();
  }, [searchParams]);

  return (
    workers && (
      <>
        <section className="flex flex-row justify-between mb-7">
          <h1 className="font-bold text-2xl text-black-12 dark:text-accent-dark">Trabajadores</h1>
          <Button
            type="secondary"
            size="small"
            action={() => setDisplayCreditPopup(true)}
            icon={
              <Icon className="stroke-white text-2xl">
                <IconUser />
              </Icon>
            }>
            Crear trabajador
          </Button>
        </section>
        <Table
          tableClass="w-full hidden lg:table mb-20"
          changeOrder={(e, c) => changeOrder(e, c)}
          rowsData={prepareTableData()}
          colsData={[
            {
              Header: 'Nombre',
              accessor: 'name',
              sortable: true,
            },
            {
              Header: 'Nombre de usuario',
              accessor: 'username',
              sortable: true,
            },
            {
              Header: 'Email',
              accessor: 'email',
              sortable: true,
            },
            {
              Header: 'Telegram id',
              accessor: 'telegram_id',
              sortable: true,
            },
            {
              Header: 'Acciones',
              accessor: 'actions',
            },
          ]}
        />
        <section className="lg:hidden">
          {workers.map((element, index) => (
            <div className="flex flex-col justify-between mb-5 bg-white shadow rounded-xl p-4" key={index}>
              <div className="flex flex-col text-center mb-3">
                <p className="text-black-12 dark:text-accent-dark font-bold">{element.name + ' ' + element.surnames}</p>
                <p className="text-black-10 text-sm ">{element.username}</p>
              </div>
              <div className="flex flex-col child:mb-3">
                <section>
                  <span className="text-black-10 dark:text-black-12 text-sm bg-black-3 px-1.5 py-0 rounded">Email</span>
                  <p className="text-black-12 dark:text-accent-dark font-bold">{element.email}</p>
                </section>
                <section>
                  <span className="text-black-10 dark:text-black-12 text-sm bg-black-3 px-1.5 py-0 rounded">
                    Telegram id
                  </span>
                  <p className="text-black-12 dark:text-accent-dark font-bold break-words">{element.telegram_id}</p>
                </section>
              </div>
              <div className="flex flex-row mx-auto">{generateActionButtons(element)}</div>
            </div>
          ))}
        </section>
        <CreditWorkerPopup
          display={displayCreditPopup}
          closePopup={async () => {
            setDisplayCreditPopup(!displayCreditPopup);
            setEditableRowData(null);
            const response = await getWorkers(window.location.search);
            setWorkers(response);
          }}
          data={editableRowData}
        />
        <PopupDelete
          display={displayDeletePopup}
          item={deleteItem}
          closePopup={() => {
            setDisplayDeletePopup(!displayDeletePopup);
          }}
          title={deleteItem.name}
          action_cancel={() => {
            setDisplayDeletePopup(false);
          }}
          action_delete={async () => {
            deleteUser(deleteItem.id);
            setDisplayDeletePopup(false);
            const response = await getWorkers(window.location.search);
            setWorkers(response);
          }}
        />
      </>
    )
  );

  function prepareTableData() {
    if (workers) {
      const rowsData = [];
      workers.forEach((element) => {
        rowsData.push({
          name: element.name + ' ' + element.surnames,
          username: element.username,
          email: element.email,
          telegram_id: element.telegram_id,
          actions: generateActionButtons(element),
        });
      });
      return rowsData;
    }
  }

  function generateActionButtons(element) {
    return (
      <section className="flex flex-row justify-around">
        <button
          onClick={async () => {
            setDeleteItem(element);
            setDisplayDeletePopup(true);
          }}
          className="text-secondary-blue hover:text-secondary-blue-dark mr-2">
          <Icon className="stroke-warning-red text-2xl">
            <Trash stroke={'#F4304A'} />
          </Icon>
        </button>
        <button
          onClick={() => {
            setEditableRowData(element);
            setDisplayCreditPopup(true);
          }}
          className="text-secondary-blue hover:text-secondary-blue-dark mr-2">
          <Icon className="stroke-black text-2xl">
            <EditText />
          </Icon>
        </button>
      </section>
    );
  }
};

export default Workers;
